import z from 'zod';
import { CollectionFlowRuleSchema, FieldSchema } from './common';
import { ValidatorSchema } from '../validation';

export const InitialUIElement = z.object({
  id: z.string(),
  valueDestination: z.string().optional(),
  defaultValue: z.any().optional(),
  params: FieldSchema.optional(),
  validate: z.array(ValidatorSchema).optional(),
  hidden: z.array(CollectionFlowRuleSchema).optional(),
  disable: z.array(CollectionFlowRuleSchema).optional(),
});
